import classNames from 'classnames';
import { IconIdentityCard } from '@medifind/icons';
import { Button } from '@medifind/shared-basic-components';
import { useClinicalTrialStepper } from '@medifind/zustand';
import GenderFooter from './GenderFooter';
import Step from './Step';
import styles from './StepShared.module.scss';

const GenderStep = ({ handleStepSubmit, stepKey, isRequired, trialCount, showOptional, loading }) => {
  const steps = useClinicalTrialStepper((state) => state.steps);
  const genderStep = steps.find(({ key }) => key === stepKey);
  const { data, skip } = genderStep || {};
  const onOptionChange = (selection) => {
    handleStepSubmit({ data: { ...selection } });
  };

  return (
    <Step
      title="Sex"
      subTitle="What sex were you assigned at birth?"
      icon={<IconIdentityCard />}
      footer={<GenderFooter />}
      optionsColStyles={styles['gender-step']}
      isRequired={isRequired}
      trialCount={trialCount}
      showTrialCount
      showOptional={showOptional}
      loading={loading}
    >
      <div className={styles['btn-row']}>
        <Button
          className={classNames(styles['btn'], { [styles['selected']]: data?.value === 'M' })}
          onClick={() => onOptionChange({ display: 'Male', value: 'M' })}
          type="normal"
          label="Male"
        />
        <Button
          className={classNames(styles['btn'], { [styles['selected']]: data?.value === 'F' })}
          onClick={() => onOptionChange({ display: 'Female', value: 'F' })}
          type="normal"
          label="Female"
        />
      </div>
    </Step>
  );
};
export default GenderStep;
